
import { Checkbox } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { containersStoreCtx } from '../../store';
import { useContext } from 'react';

export const HDWPFcheckbox = observer(() => {
  const { chosenContainer } = useContext(containersStoreCtx);
  const handleChange = (
    _: React.SyntheticEvent,
    data: boolean,
  ) => chosenContainer?.setHDWPF(data);
  return (
    <Checkbox
      checked={chosenContainer?.hdwpf}
      onChange={handleChange}
    />
  );
});
